import styled from "styled-components";

export const Group = styled.div`
  &:last-child {
    border-top: 1px solid ${props => props.theme.borderColor};
  }
`;
